import { useEffect, useState } from "react";
import VendorDetail from "./VendorDetail";
import { useSelector, useDispatch } from "react-redux";
import purchaseOrderOperations from "../../../../../redux/PurchaseOrder/operations";
import purchaseOrderSelectors from "../../../../../redux/PurchaseOrder/selectors";
import { getVendorDetails } from "Store/Organization/VendorDetails/VendorDetailsAction";
import { CONSTANTS } from "client/utils/constants";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";

const VendorDetailContainer = (props: any) => {
  const dispatch = useDispatch();
  const dispatchStepperData =
    purchaseOrderOperations.dispatchSetPurchaseorderStepperData(dispatch);

const { isBulkOrder } = props
  const { 
    vendorDetails,
    isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked,
    purchaseOrderStepperDataArr
  }: any = useSelector((state: any) => ({
    vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
    isVehicleConsolidatedChecked : state.FleetProcessingReducer.isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked : state.FleetProcessingReducer.isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked : state.FleetProcessingReducer.isNonstandardConsolidatedChecked,
    purchaseOrderStepperDataArr:
      purchaseOrderSelectors.getPurchaseOrderStepperData(state),
  }));

  const dispatchStepperDataArr =
  purchaseOrderOperations.dispatchSetPurchaseorderStepperInfo(dispatch);

  const [showDealerSection, setShowDealerSection] = useState(true);
  const [vendorSearchText, setVendorSearchText] = useState<string | undefined>(undefined);
  const [vendorDropdownList, setVendorDropdownList] = useState<any>([]);
  const [vendor, setVendor] = useState<any>({})

  const [sameVendorSearchText, setSameVendorSearchText] = useState<string | undefined>(undefined);
  const [sameVendor, setSameVendor] = useState<any>({})

  useEffect(() => {
    if(props?.purchaseOrderStepperData?.poDealerDetails?.vendorABNumber){
      const item = props?.purchaseOrderStepperData?.poDealerDetails;
      setVendor({ text: item.dealerName, value: item.dealerName, label: item.vendorABNumber + "-" + item.dealerName, key: item.dealerName, ...item });
    }
    if(props?.purchaseOrderStepperData?.poVendorDetails?.vendorAbNumber){
      const item = props?.purchaseOrderStepperData?.poVendorDetails;
      setSameVendor({ text: item.vendorName, value: item.vendorName, label: item.vendorAbNumber + "-" + item.vendorName, key: item.vendorName, ...item });
    }
  }, [])

  useEffect(() => {
    ///Modified dropDown values as required
    const list = vendorDetails?.map((item: any) =>
      ({ text: item.alphaName, value: item.alphaName, label: item.abnumber + "-" + item.alphaName, key: item.abnumber, ...item })
    );
    setVendorDropdownList(list);
  }, [vendorDetails])

  const debouncedDealerText = useDebounce(vendorSearchText, 500)
  const filterOptionVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
      setVendorSearchText(value)
    }
  };

  const dealerSelectOnBlur = () => {
    if(vendorSearchText){
      setVendorSearchText('')
    }
  }

  const filterOptionsameVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
      setSameVendorSearchText(value)
    }
  };

  const sameDealerSelectOnBlur = () => {
    if(sameVendorSearchText){
      setSameVendorSearchText('')
    }
  }

  useEffect(() => {
    if (debouncedDealerText?.length > 2) {
      dispatch(getVendorDetails(debouncedDealerText.replace(/[^\w\s]/gi, "")));
    } else if(debouncedDealerText === ''){
      dispatch(getVendorDetails(''))
    }
  }, [debouncedDealerText])

  const debouncedVendorText = useDebounce(sameVendorSearchText, 500)

  useEffect(() => {
    if (debouncedVendorText?.length > 2) {
      dispatch(getVendorDetails(debouncedVendorText.replace(/[^\w\s]/gi, "")));
    } else if(debouncedVendorText === ''){
      dispatch(getVendorDetails(''))
    }
  }, [debouncedVendorText])


  useEffect(() => {
    if (props?.purchaseOrderStepperData?.poDealerDetails?.vendorABNumber) {
      const item = props?.purchaseOrderStepperData?.poDealerDetails;
      setVendor({ text: item.dealerName, value: item.dealerName, label: item.vendorABNumber + "-" + item.dealerName, key: item.dealerName, ...item });
    }
  }, [props?.purchaseOrderStepperData?.poDealerDetails])

  useEffect(() => {
    if (props?.purchaseOrderStepperData?.poVendorDetails?.vendorAbNumber) {
      const item = props?.purchaseOrderStepperData?.poVendorDetails;
      setSameVendor({ text: item.vendorName, value: item.vendorName, label: item.vendorAbNumber + "-" + item.vendorName, key: item.vendorName, ...item });
    }
  }, [props?.purchaseOrderStepperData?.poVendorDetails])
  
  const purchaseitemDetails = (val: any, item: any, fleetId?: any) => {
    const purchaseOrderData = {
      ...val,
      isDealerVendorSave : val?.fleetRequestDetailId == fleetId ? false : val?.isDealerVendorSave,
      poDealerDetails: {
        ...(val.poDealerDetails || {}),
        dealerAbNumber: item?.abnumber,
        dealerName: item?.alphaName,
        dealerAdd1: item?.address1,
        dealerAdd2: item?.address2,
        dealerAdd3: item?.address3,
        dealerState: item?.state,
        dealerCity: item?.city,
        dealerZip: item?.postalCode,
        dealerPhone: item?.phoneAreaCode + item?.phoneNumber,
        vendorABNumber: item?.abnumber
      },
    };
    props.setErrors((prev: any) => ({
      ...prev,
      dealerAbNumber: !purchaseOrderData?.poDealerDetails?.dealerAbNumber,
      dealerName: !purchaseOrderData?.poDealerDetails?.dealerName,
      dealerAdd1: !purchaseOrderData?.poDealerDetails?.dealerAdd1,
      dealerState: !purchaseOrderData?.poDealerDetails?.dealerState,
      dealerZip: !purchaseOrderData?.poDealerDetails?.dealerZip,
      dealerPhone: !purchaseOrderData?.poDealerDetails?.dealerPhone,
      vendorABNumber: !purchaseOrderData?.poDealerDetails?.vendorABNumber,
      dealerCity: !purchaseOrderData?.poDealerDetails?.dealerCity
    }));
    return purchaseOrderData;
  }

  const onChangeVendorName = (item: any, fleetId: any) => {
     setVendor(item)
     
     const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
     let consolidatedPoData : any = []
    if(isVehicleConsolidatedChecked === props.itemDetails?.orderRequestType){
      consolidatedPoData = saveConsolidatedPoDataArr.map((val : any) => {
        if(val?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
          const data = purchaseitemDetails(val, item, fleetId)
          return data
        } 
        return val
      })

      dispatchStepperDataArr(consolidatedPoData);
    }
    else if(isManageEquipConsolidatedChecked === props?.itemDetails?.orderRequestType){ 
      consolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
        if(val?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
          const data = purchaseitemDetails(val, item, fleetId)
          return data
        } 
        return val 
      })
      dispatchStepperDataArr(consolidatedPoData);
    }
    else if(isNonstandardConsolidatedChecked === props.itemDetails?.orderRequestType){
      consolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
        if(val?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
          const data = purchaseitemDetails(val, item, fleetId)
          return data
        }  
        return val
      })
      dispatchStepperDataArr(consolidatedPoData);
    }
    else{
      setVendor(item)
      const data = purchaseitemDetails(props?.purchaseOrderStepperData, item, fleetId)
      const purchaseStepperArrTemp = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))?.map((item: any) => {
        if(item?.fleetRequestDetailId === props?.purchaseOrderStepperData?.fleetRequestDetailId){
          return {...item, isDealerVendorSave: false}
        } 
        return item
      })
      dispatchStepperDataArr(purchaseStepperArrTemp);
      dispatchStepperData(data);
    }
    setVendorSearchText('')
    }

    const purchaseitemDealerDetails = (val: any, item: any, fleetId?: any) => {
      const purchaseOrderData = {
        ...val,
        isDealerVendorSave : val?.fleetRequestDetailId == fleetId ? false : val?.isDealerVendorSave,
        poVendorDetails: {
          ...(val.poVendorDetails || {}),
          vendorAbNumber: item?.abnumber,
          vendorName: item?.alphaName,
          vendorAdd1: item?.address1,
          vendorAdd2: item?.address2,
          vendorState: item?.state,
          vendorCity: item?.city,
          vendorZip: item?.postalCode
        },
      };
      props.setErrors((prev: any) => ({
        ...prev,
        vendorAbNumber: !purchaseOrderData?.poVendorDetails?.vendorAbNumber,
        vendorName: !purchaseOrderData?.poVendorDetails?.vendorName,
        vendorAdd1: !purchaseOrderData?.poVendorDetails?.vendorAdd1,
        vendorState: !purchaseOrderData?.poVendorDetails?.vendorState,
        vendorZip: !purchaseOrderData?.poVendorDetails?.vendorZip,
        vendorCity: !purchaseOrderData?.poVendorDetails?.vendorCity,
      }));
      return purchaseOrderData;
    }

    const purchaseSameAsDealerDetails = (val?: any, item?: any, fleetId?: any) => {
      if(item){
      const purchaseOrderData = {
        ...val,
        isDealerVendorSave : val?.fleetRequestDetailId == fleetId ? false : val?.isDealerVendorSave,
        isVendorSameAsDealer: item,
        poVendorDetails: {
          fleetRequestVendorId: val?.poDealerDetails?.fleetRequestDealerId,
          vendorAbNumber: val?.poDealerDetails?.vendorABNumber,
          vendorName: val?.poDealerDetails?.dealerName,
          vendorContactEmail : val?.poDealerDetails?.dealerContactEmail,
          vendorAdd1: val?.poDealerDetails?.dealerAdd1,
          vendorAdd2: val?.poDealerDetails?.dealerAdd2,
          vendorState: val?.poDealerDetails?.dealerState,
          vendorZip: val?.poDealerDetails?.dealerZip,
          vendorCity: val?.poDealerDetails?.dealerCity
        },
      };
      props.setErrors((prev: any) => ({
        ...prev,
        vendorAbNumber: false,
        vendorName: false,
        vendorAdd1: false,
        vendorState: false,
        vendorZip: false,
        vendorCity: false
      }));
      return purchaseOrderData;
    }else{
      const purchaseOrderData = {
        ...val,
        isVendorSameAsDealer: item,
        isDealerVendorSave : val?.fleetRequestDetailId == fleetId ? false : val?.isDealerVendorSave,
        poVendorDetails: { ...val.poVendorDetails },
      };
      props.setErrors((prev: any) => ({
        ...prev,
        vendorAbNumber: !purchaseOrderData?.poVendorDetails?.vendorAbNumber,
        vendorName: !purchaseOrderData?.poVendorDetails?.vendorName,
        vendorAdd1: !purchaseOrderData?.poVendorDetails?.vendorAdd1,
        vendorState: !purchaseOrderData?.poVendorDetails?.vendorState,
        vendorZip: !purchaseOrderData?.poVendorDetails?.vendorZip,
        vendorCity: !purchaseOrderData?.poVendorDetails?.vendorCity,
      }));
      return purchaseOrderData;
    }
    }

    const onChangeSameAsVendorName = (item: any, fleetId?: any) => {
      setSameVendor(item)
      
      const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
      let consolidatedPoData : any = []
     if(isVehicleConsolidatedChecked === props.itemDetails?.orderRequestType){
      consolidatedPoData = saveConsolidatedPoDataArr.map((val : any) => {
         if(val?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
           const data = purchaseitemDealerDetails(val, item, fleetId)
           return data
         } 
         return val
       })
 
       dispatchStepperDataArr(consolidatedPoData);
     }
     else if(isManageEquipConsolidatedChecked === props?.itemDetails?.orderRequestType){ 
      consolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
         if(val?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
           const data = purchaseitemDealerDetails(val, item, fleetId)
           return data
         } 
         return val 
       })
       dispatchStepperDataArr(consolidatedPoData);
     }
     else if(isNonstandardConsolidatedChecked === props.itemDetails?.orderRequestType){
      consolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
         if(val?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
           const data = purchaseitemDealerDetails(val, item, fleetId)
           return data
         }  
         return val
       })
       dispatchStepperDataArr(consolidatedPoData);
     }
     else{
      setSameVendor(item)
       const data = purchaseitemDealerDetails(props?.purchaseOrderStepperData, item, fleetId)
       dispatchStepperData(data);
     }
     setSameVendorSearchText('')
     }

  const vendorSameAsDealeToggleClick = (event:any, checked:any, unknownPara: any, fleetId?: any) => {
    if(checked){
      setShowDealerSection(false)
    }
    else {
      setShowDealerSection(true)
    }  
    const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
      let ConsolidatedPoData : any = []
     if(isVehicleConsolidatedChecked === props.itemDetails?.orderRequestType){
       ConsolidatedPoData = saveConsolidatedPoDataArr.map((val : any) => {
 
         if(val?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
           const data = purchaseSameAsDealerDetails(val, checked, fleetId)
           return data
         } 
         return val
       })
 
       dispatchStepperDataArr(ConsolidatedPoData);
     }
     else if(isManageEquipConsolidatedChecked === props?.itemDetails?.orderRequestType){ 
       ConsolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
         if(val?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
           const data = purchaseSameAsDealerDetails(val, checked, fleetId)
           return data
         } 
         return val 
       })
       dispatchStepperDataArr(ConsolidatedPoData);
     }
     else if(isNonstandardConsolidatedChecked === props.itemDetails?.orderRequestType){
       ConsolidatedPoData = saveConsolidatedPoDataArr?.map((val : any) => {
         if(val?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !val?.pocipDetails && !val.poNumber && val?.itemStatus != CONSTANTS?.ORDER_STATUS.CANCELLED){
 
           const data = purchaseSameAsDealerDetails(val, checked, fleetId)
           return data
         }  
         return val
       })
       dispatchStepperDataArr(ConsolidatedPoData);
     }
     else{
       const data = purchaseSameAsDealerDetails(props?.purchaseOrderStepperData, checked, fleetId)
 
       dispatchStepperData(data);
     }
  } 

 
  
  return (
    <VendorDetail
      errors={props.errors}
      handleChange={props.handleChange}
      popupPrimarybtnOnclick={props.popupPrimarybtnOnclick}
      Popupcontent={props.Popupcontent}
      hideDialog={props.onDismiss}
      popupOutlinebtnOnclick={props.popupOutlinebtnOnclick}
      handleClickCancel={props.handleClickCancel}
      purchaseOrderStepperData={props.purchaseOrderStepperData}
      updateValue={props.updateValue}
      savePurchaseOrder={props.savePurchaseOrder}
      //handleClickRestore={handleClickRestore}
      isCompleted={props.isCompleted}
      vendorDropdownList={vendorDropdownList}
      onChangeVendorName={onChangeVendorName}
      vendorSearchText={vendorSearchText}
      dealerSelectOnBlur={dealerSelectOnBlur}
      vendor={vendor}
      filterOptionVendor={filterOptionVendor}
      vendorSameAsDealeToggleClick={vendorSameAsDealeToggleClick}
      showDealerSection={showDealerSection}
      onChangeSameAsVendorName = {onChangeSameAsVendorName}
      sameVendor = {sameVendor}
      filterOptionsameVendor = {filterOptionsameVendor}
      sameDealerSelectOnBlur = {sameDealerSelectOnBlur}
      sameVendorSearchText = {sameVendorSearchText}
      isBulkOrder={isBulkOrder}
    />
  );
};

export default VendorDetailContainer;
